type CentrifugeLike = { state: string }
type CentrifugeErrorCtx = { type?: string }

function isBrowserOnline(): boolean {
  return typeof navigator === 'undefined' || navigator.onLine
}

/**
 * Site-wide "connection lost" banner is for browser network loss only.
 * Centrifuge reconnects / token refresh while online must not trigger it.
 */
export function shouldMarkCentrifugeConnectionProblem(
  ctx: CentrifugeErrorCtx | undefined,
  centrifuge: CentrifugeLike | null | undefined,
): boolean {
  if (isBrowserOnline()) return false
  if (!centrifuge) return true

  const type = ctx?.type ?? ''
  if (centrifuge.state === 'connected') {
    if (
      type === 'refreshToken' ||
      type === 'refresh' ||
      type === 'connectToken' ||
      type === 'configuration'
    ) {
      return false
    }
  }

  return type === 'transport' || centrifuge.state !== 'connected'
}

export function isCentrifugeConnected(centrifuge: CentrifugeLike | null | undefined): boolean {
  return centrifuge?.state === 'connected'
}
